import { API_DEV } from "constants/api";

import { header, handleAPIResult, serialize, formatMaterialFilters } from "utils";

export const complianceService = {
  list,
  get,
  create,
  update,
  powerBiUrl,
};

function list(filters = {}, material = {}) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  var qs =
    Object.keys(material).length === 0
      ? serialize(filters)
      : formatMaterialFilters(filters, material);
  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/compliances?" + qs, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function get(id) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/compliances/" + id, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function create(note) {
  const postInfo = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...header(),
    },

    body: JSON.stringify({
      compliance: note,
    }),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/compliances", postInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function update(note) {
  const patchInfo = {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...header(),
    },

    body: JSON.stringify({
      compliance: note,
    }),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/compliances/" + note.id, patchInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Retourne l'url pour power bi
function powerBiUrl() {
  return API_DEV + "/compliances";
}
